import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class GascomService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/gascom';
  }

  public get(idCreditos : number) {
    let myParams = new URLSearchParams();
    myParams.append('idCreditos', idCreditos.toString());

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_url , myoptions);
  }

  public save( credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }


  public validateCarburacion(gascom : any){
    let error = [];

    if(!this.validatorService.required(gascom.numero_cliente)){
      error["numero_cliente"] = this.errorService.required;
    }

    if(!this.validatorService.required(gascom.estacion_planta)){
      error["estacion_planta"] = this.errorService.required;
    }

    if(!this.validatorService.required(gascom.marca_tanque)){
      error["marca_tanque"] = this.errorService.required;
    }

    if(!this.validatorService.required(gascom.numero_tanque)){
      error["numero_tanque"] = this.errorService.required;
    }

    if(!this.validatorService.required(gascom.capacidad_tanque)){
      error["capacidad_tanque"] = this.errorService.required;
    }

    if(!this.validatorService.required(gascom.fecha_fabricacion)){
      error["fecha_fabricacion"] = this.errorService.required;
    } 

    if(!this.validatorService.required(gascom.marca_sistema)){
      error["marca_sistema"] = this.errorService.required;
    }

    if(!this.validatorService.required(gascom.cilindraje)){
      error["cilindraje"] = this.errorService.required;
    }

    return error;
  }

  public validateEstacionario(gascom : any){
    let error = [];

    if(!this.validatorService.required(gascom.numero_cliente)){
      error["numero_cliente"] = this.errorService.required;
    }

    if(!this.validatorService.required(gascom.estacion_planta)){
      error["estacion_planta"] = this.errorService.required;
    }

    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/creditos/gascom.service.ts